// src/services/biometric.service.js
import { api } from './api';

class BiometricService {
    // ─── Devices ────────────────────────────────────────────────
    async getDevices() {
        const response = await api.get('/api/biometric/devices');
        return response.data;
    }

    async registerDevice(data) {
        const response = await api.post('/api/biometric/devices', data);
        return response.data;
    }

    async updateDevice(id, data) {
        const response = await api.put(`/api/biometric/devices/${id}`, data);
        return response.data;
    }

    async deleteDevice(id) {
        const response = await api.delete(`/api/biometric/devices/${id}`);
        return response.data;
    }

    // ─── User Mappings ─────────────────────────────────────────
    async getUserMappings() {
        const response = await api.get('/api/biometric/users');
        return response.data;
    }

    async createUserMapping(data) {
        const response = await api.post('/api/biometric/users', data);
        return response.data;
    }

    async deleteUserMapping(id) {
        const response = await api.delete(`/api/biometric/users/${id}`);
        return response.data;
    }

    async bulkImportMappings(mappings) {
        const response = await api.post('/api/biometric/users/bulk', { mappings });
        return response.data;
    }

    // ─── Punch Logs ────────────────────────────────────────────
    async getPunchLogs(params = {}) {
        const query = new URLSearchParams(params).toString();
        const response = await api.get(`/api/biometric/logs?${query}`);
        return response.data;
    }

    async reprocessLogs(ids = []) {
        const response = await api.post('/api/biometric/logs/reprocess', { ids });
        return response.data;
    }

    async importPunches(punches) {
        const response = await api.post('/api/biometric/import', { punches });
        return response.data;
    }
}

const biometricService = new BiometricService();
export default biometricService;
